import React, { useState, useEffect } from "react"
import { useParams } from "react-router-dom"
import Styles from './JobInfo.module.scss'
import { useNavigate } from "react-router-dom"
import { useAPI } from "components/lib.js";
import { LoadingBackdrop } from "components/global/LoadingBackdrop/LoadingBackdrop.js"
//mui
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

//icons
import DoneAllIcon from '@mui/icons-material/DoneAll';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { Questionnaire } from "components/global/Questionnaire/Questionnaire.js"
import { ToastContainer, toast } from 'react-toastify';

import { AuthContext } from "components/lib.js";
import { useContext } from "react";

export function JobInfo(props) {
    const Event = require('components/lib').Event;

    const [data, setData] = useState()
    const { context } = useParams()
    const { job_id } = useParams()
    const navigate = useNavigate();
    const jobData = useAPI(props.endpoint, 'GET')

    const containerName = process.env.REACT_APP_AZURE_BLOB_CONTAINER_NAME_HIRING;

    const [showQuestionnaire, setShowQuestionnaire] = useState(false)

    const authContext = useContext(AuthContext);

    useEffect(() => {
        if (jobData?.data) {
            if (context === 'view') {
                Event(`website_click`);
                Event(`website_click_job_${job_id}`);
            }
            if (jobData?.data?.isApplied) {
                navigate(`/hiring/jobs/${job_id}/applied`)
            }
            setData(jobData?.data[0])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [jobData?.loading])

    const handleProgressAccess = (item) => {
        toast.dark(`You have already attempted the ${item}`, {
            type: 'info',
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };
   
    function onApply(){
        if(!authContext?.user){
            return navigate(`/signup?source=website&origin=job&name=${job_id}`)
        }
        setShowQuestionnaire(!showQuestionnaire);
    }

    return (
        <>
            <ToastContainer
                id="warning-toast"
                position="top-right"
                autoClose={10000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                pauseOnFocusLoss
                draggable
                pauseOnHover
                limit={4}
            />
            {
                !data ?
                    <LoadingBackdrop isOpen={true} />
                    :
                    <div className={Styles.ancestorContainer}>
                        {authContext?.user && <button
                            id="backToJobBoard"
                            className={Styles.backButton}
                            onClick={() => { navigate('/hiring/jobs') }}
                        >
                            <ArrowBackIcon fontSize="small" sx={{ mr: '0.01em' }} /> Back to Job Board
                        </button>}
                        <div className={Styles.head}>
                            <div className={Styles.orgIcon}>
                                <img src={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}/${containerName}/logos/${data?.org_logo}`} alt="org logo" />
                            </div>
                            <div className={Styles.jobTitle}>
                                <p className={Styles.jobPosition}>{data?.job_position}</p>
                                <p className={Styles.orgName}>{data?.org_name}</p>

                                <div className={Styles.tagsContainer}>
                                    {(data) && Object.entries(data?.job_details).map(([key, value]) => (
                                        <div key={key} className={Styles.tags}>
                                            {key === 'experience' ? <p>{value[0]} - {value[1]} years</p> : <p>{value}</p>}
                                        </div>
                                    ))}
                                </div>
                            </div>
                            {(data?.progressData && data?.progressData?.app_status === 'shortlisted' && (data?.quiz !== null || data?.live_assessment !== null)) ?
                                <div className={Styles.ApplyBtnContainer} style={{}}>
                                    <h2 style={{ paddingRight: '2rem', fontWeight: 600, textAlign: 'right', fontSize: '1.125rem', color: 'black' }}>
                                        Complete the Following to finish your application
                                    </h2>
                                    <Timeline position="left" sx={{ width: '', marginLeft: 'auto' }}>


                                        {
                                            data?.quiz !== null && <TimelineItem sx={{ cursor: 'pointer' }} onClick={() => { data?.progressData?.quiz_status ? handleProgressAccess('quiz') : navigate(`/hiring/jobs/${job_id}/quiz/hire`); }}>
                                                <TimelineSeparator>
                                                    <TimelineDot
                                                        sx={{ backgroundColor: data?.progressData?.quiz_status && "#4bb14f" }}
                                                    >
                                                        {data?.progressData?.quiz_status ? <DoneAllIcon /> : <PlayArrowIcon />}
                                                    </TimelineDot>
                                                    <TimelineConnector
                                                        sx={{ display: data?.live_assessment === null && 'none' }}

                                                    />
                                                </TimelineSeparator>
                                                <TimelineContent >
                                                    <p style={{ width: '20vw', marginTop: '0.6rem', fontSize: '1.3rem' }}>
                                                        Quiz
                                                    </p>
                                                </TimelineContent>
                                            </TimelineItem>
                                        }
                                        {
                                            data?.live_assessment !== null &&
                                            <TimelineItem
                                                sx={{ cursor: 'pointer' }}
                                                onClick={() => { data?.progressData?.assessment_status ? handleProgressAccess("Live Assessment") : navigate(`/hiring/jobs/${job_id}/assessment/${data?.live_assessment?.resource_name}`); }}
                                            >
                                                <TimelineSeparator>
                                                    <TimelineDot
                                                        sx={{ backgroundColor: data?.progressData?.assessment_status && "#4bb14f" }}
                                                    >
                                                        {data?.progressData?.assessment_status ? <DoneAllIcon /> : <PlayArrowIcon />}
                                                    </TimelineDot>
                                                </TimelineSeparator>
                                                <TimelineContent >
                                                    <p style={{ width: '20vw', marginTop: '0.6rem', fontSize: '1.3rem' }}>
                                                        Live Assessment
                                                    </p>
                                                </TimelineContent>
                                            </TimelineItem>
                                        }
                                    </Timeline>
                                </div> : null}
                            {!data?.progressData && <div className={Styles.ApplyBtnContainer}>
                                <button className={Styles.applyBtn} onClick={onApply}>APPLY</button>
                            </div>}
                        </div>
                        <div className={Styles.detailsContainer}>
                            {data?.progressData?.app_status &&
                                <>
                                    <h2>
                                        Application Status
                                    </h2>
                                    <button id="app_status" className={Styles.app_status}>
                                        {data?.progressData?.app_status === "inReview" ? "IN-REVIEW" : `${data?.progressData?.app_status.toUpperCase()}`}
                                    </button>
                                </>
                            }
                            <h2>
                                Skills
                            </h2>
                            <div className={Styles.skillTags}>
                                {data?.required_skills?.map((skill, index) => {
                                    return (

                                        <div
                                            key={index}
                                            className={Styles.skills}
                                            style={{
                                                backgroundColor:
                                                    skill.matched === 0 || skill.matched === 1 ?
                                                        " #d0ffcf" : "#f1f1f1"
                                            }}
                                        >
                                            <p
                                                style={{
                                                    fontSize: '14px',
                                                    color:
                                                        skill.matched === 0 || skill.matched === 1 ?
                                                            " #065104" : "#00000"
                                                    , fontWeight: 600
                                                }}>
                                                {skill?.tag_name}
                                                {skill.matched === 1 && <span style={{ paddingLeft: "0.2rem" }} title="Verified By AIVAGAM">  <CheckCircleIcon fontSize="small" /> </span>}
                                            </p>
                                        </div>
                                    )
                                })}
                            </div>
                            <h2>
                                About this role
                            </h2>
                            <p style={{ marginTop: '1rem' }}>
                                {data?.descr}
                            </p>

                            <h2 style={{ marginTop: '1.5rem' }}>
                                Qualifications
                            </h2>
                            {
                                data?.qualification?.map((qual, index) => {
                                    return (
                                        <span style={{ display: 'flex', alignItems: 'center', gap: "8px" }} key={qual + index}>
                                            <p style={{ fontSize: '32px', marginBottom: 'auto' }}> &#x2022;</p>
                                            <p>  {qual}</p>

                                        </span>
                                    )
                                })
                            }

                            <h2 style={{ marginTop: '1.5rem' }}>
                                Responsibility
                            </h2>
                            {
                                data?.responsibility?.map((resp, index) => {
                                    return (
                                        <span style={{ display: 'flex', alignItems: 'center', gap: "8px" }} key={resp + index}>
                                            <p style={{ fontSize: '32px', marginBottom: 'auto' }}> &#x2022;</p>
                                            <p>{resp}</p>

                                        </span>
                                    )
                                })
                            }
                        </div>
                        <Dialog
                            open={showQuestionnaire}
                            onClose={() => { setShowQuestionnaire(!showQuestionnaire) }}
                        // sx={{ height: 'fit-content', width: 'fit-content', }}
                        >
                            <DialogTitle sx={{ fontWeight: 600 }}>
                                Basic Details
                            </DialogTitle>
                            <DialogContent>
                                <Questionnaire
                                    showQuestionnaire={showQuestionnaire}
                                    setShowQuestionnaire={setShowQuestionnaire}
                                    endpoint={`/api/job/${job_id}/apply`}
                                    redirect={`/hiring/jobs/${job_id}/applied`}
                                />
                            </DialogContent>
                        </Dialog>


                    </div>
            }
        </>
    )
}
